<template>
    <div class="scrolled  text-bat">
        <section class="pt-3 pt-md-3 ">
            <div class="container py-2">
                <div class="container">
                    <div class="breadcrumbs-retos">
                        <a href="/home-bat">
                            <img src="/img/icons/homeBread.svg" alt="" />
                        </a>
                        <a class="link cursor-pointer" @click="modal_out_challenge = true">A la practica</a>
                        <a class="link cursor-pointer" @click="modal_out_challenge = true">Retos /</a>
                        <span class="color-active-miga"><strong>Detalle de retos</strong></span>
                    </div>
                    <a href="#" @click="returnChallenge()"><img src="/img/icons/regresar.svg" alt="icon"></a>
                </div>
            </div>
        </section>

        <div class="d-flex justify-content-center">
            <section v-if="approved" class="challenge-upload-photo mb-0 mt-2 text-center">
                <div v-if="approved.is_approved === 'true'" class="alert alert-success alert-state w-100" role="alert">
                    Reto completo
                </div>
                <div v-if="approved.is_approved === 'false'" class="alert alert-danger alert-state w-100" role="alert">
                    Reto no aprobado
                </div>
                <div v-if="approved.is_approved === 'review'" class="alert alert-warning alert-state w-100"
                     role="alert">
                    En revisión
                </div>
                <div v-if="approved.is_approved === 'read'" class="alert alert-secondary alert-state w-100"
                     role="alert">
                    No ha participado
                </div>
                <div v-else class="alert alert-secondary w-100" role="alert">
                    No ha participado
                </div>
            </section>
            <section v-else class="challenge-upload-photo mb-0 mt-2 text-center">
                <div class="alert alert-secondary w-100" role="alert">
                    No ha participado
                </div>
            </section>
        </div>
        <section class="container soup pt-0 vh-100 alphabet-soup-styles">
            <div class="container">
                <div class="row">
                    <div class="col-lg-5 col-md-12 col-sm-12">
                        <h2>{{ challenge.challenge_name }}</h2>
                        <div v-html="challenge.description"></div>
                        <div class="oldList">
                            <div id="words">
                                <div></div>
                            </div>
                        </div>
                    </div>
                    <div class="col-lg-7 col-sm-12 col-md-12">
                        <div class="row">
                            <div class="container">
                                <div id="puzzle"></div>
                            </div>
                            <div class="col-sm-12">
                                <input class="inputHidden words_count" id="words_count" v-model="words_count"
                                       type="hidden">
                                <el-alert
                                    title="Haz completado todas las palabras de este reto, no olvides Enviar Reto para obtener los puntos."
                                    type="warning"
                                    class="mt-4 mb-3"
                                    id="alert"
                                    style="display: none"
                                >
                                </el-alert>
                                <button class="save mt-2 btn" style="background-color: rgb(128,128,128);" id="save" disabled type="button"
                                        @click="finishSoup()">
                                    Enviar reto
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
        <el-dialog
            :visible.sync="modal_out_challenge"
            :width="$mq === 'sm' ? '90%' : '50%'"
            :close-on-click-modal="false"
            :close-on-press-escape="false"
            key="out_challenge_modal"
            :show-close="false">
            <div class="modals">
                <img src="/img-version2/modal/trash.svg" alt="image 8">
                <h6 class="my-3 mx-auto">¿Estás seguro que deseas salir del reto?</h6>
                <p class="mt-4">Si sales, el progreso de tu reto <strong class="h6">no </strong>será guardado</p>
                <div class="modals d-flex align-items-center flex-column justify-content-center">
                    <div class="row">
                        <div class="col-6">
                            <div class="buttonOne" type="buttoNot" @click="modal_out_challenge = false">No, volver</div>
                        </div>
                        <div class="col-6">
                            <div class="buttonTwo" type="buttoYes" @click="returnChallenge()">Sí, salír</div>
                        </div>
                    </div>
                </div>
            </div>
        </el-dialog>
        <div v-if="loading">
            <initial-loading></initial-loading>
        </div>
    </div>
</template>
<script>

export default {
    props: {
        url_storage: {
            default: null,
        },
        approved: {
            default: null,
        },
        challenge: {
            default: null,
        },
        words: {
            default: null,
        },
    },
    data() {
        return {
            isMobile: false,
            modal_out_challenge: false,
            words_count: 0,
            loading: 0,
            data: {
                inputWords: 0,
                challenge_amount: 0,
                challenge_name: '',
                calification: 0,
                challenge_id: 0,
                challenge_lapse_id: 0,
            },
        };
    },

    mounted() {
        this.loadScript('/js/vendor/wordfind.js', () => {
            this.loadScript('/js/vendor/wordfindgame.js', () => {
                if (this.words) {
                    this.initializeWordFind();
                } else {
                    console.error('El valor de $props.words es undefined. Verifica la asignación de datos en el componente padre.');
                }
            });
        });
        this.data.challenge_amount = this.challenge.points_to_win;
        this.data.challenge_name = this.challenge.challenge_name;
        this.data.calification = this.challenge.automatic_qualification;
        this.data.challenge_id = this.challenge.id;
        this.data.challenge_lapse_id = this.challenge.lapse_id;
    },
    methods: {
        loadScript(src, callback) {
            const script = document.createElement('script');
            script.src = src;
            script.type = 'text/javascript';
            script.async = true;
            script.onload = callback;
            document.head.appendChild(script);
        },
        initializeWordFind() {
            if (typeof WordFindGame !== 'undefined') {
                this.words.map((word) => WordFindGame.insertWordBefore($('.oldList #words div'), word));
                window.game = new WordFindGame('#puzzle', {height: 8, width: 8});
            } else {
                console.error('WordFindGame no está definido. Verifica la carga de wordfindgame.js.');
            }
        },
        createWordFindGame() {
            // Inicializar WordFindGame aquí después de que los scripts se hayan cargado
        },
        addOneToInputWords() {
            this.inputWords = (parseInt(this.inputWords) || 0) + 1;
        },
        finishSoup() {
            this.data.inputWords = document.getElementById('words_count').value;
            this.loading++;
            axios.post('store', this.data).then((response) => {
                if (response.data.status === 'success') {
                    this.returnChallenge()
                } else {
                    alert('Ha ocurrido un error al guardar el reto');
                }
            });
        },
        returnChallenge() {
            window.location.href = '/retos?page=1&option=challenge';
        },
        listLetters() {
            this.isMobile = window.innerWidth < 768;
        },
    },
}
</script>
